import { Paragraph } from '@/components/Paragraph';

import { StyledDayTag } from './styles';

interface DayTagProps {
  startDay: string;
  endDay: string;
}

export function DayTag({ startDay, endDay }: DayTagProps) {
  return (
    <StyledDayTag>
      <Paragraph weight={600} color="primary">
        Day {startDay} t/m {endDay}
      </Paragraph>
    </StyledDayTag>
  );
}
